/* =========================================================
   Coach Glenn Games - Theme JS
   Cart drawer, mobile nav, accordion, gallery, quantity.
   ========================================================= */

(function () {
  'use strict';

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  /* -- Scroll lock helper ----------------------------- */
  const lockScroll = () => document.body.classList.add('scroll-lock');
  const unlockScroll = () => document.body.classList.remove('scroll-lock');

  /* -- Overlay ---------------------------------------- */
  const overlay = qs('[data-overlay]');
  function showOverlay() { if (overlay) overlay.hidden = false; }
  function hideOverlay() { if (overlay) overlay.hidden = true; }
  if (overlay) overlay.addEventListener('click', closeAll);

  function closeAll() {
    closeCart();
    closeMenu();
    hideOverlay();
    unlockScroll();
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* -- Mobile menu ------------------------------------ */
  const menuToggle = qs('[data-menu-toggle]');
  const menuClose = qs('[data-menu-close]');
  const mobileNav = qs('[data-mobile-nav]');

  function openMenu() {
    if (!mobileNav) return;
    mobileNav.dataset.open = 'true';
    menuToggle?.setAttribute('aria-expanded', 'true');
    showOverlay();
    lockScroll();
  }
  function closeMenu() {
    if (!mobileNav) return;
    delete mobileNav.dataset.open;
    menuToggle?.setAttribute('aria-expanded', 'false');
  }
  menuToggle?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeAll);

  /* -- Cart drawer ------------------------------------ */
  const cartDrawer = qs('[data-cart-drawer]');
  const cartOpenBtn = qs('[data-cart-open]');
  const cartCloseBtn = qs('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.dataset.open = 'true';
    cartDrawer.setAttribute('aria-hidden', 'false');
    showOverlay();
    lockScroll();
  }
  function closeCart() {
    if (!cartDrawer) return;
    delete cartDrawer.dataset.open;
    cartDrawer.setAttribute('aria-hidden', 'true');
  }
  cartOpenBtn?.addEventListener('click', openCart);
  cartCloseBtn?.addEventListener('click', closeAll);

  /* -- Live cart refresh after add-to-cart ----------- */
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      qsa('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      const section = await fetch('?sections=cart-drawer');
      const data = await section.json();
      if (data['cart-drawer']) {
        const tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        const fresh = tmp.querySelector('[data-cart-drawer]');
        if (fresh && cartDrawer) {
          cartDrawer.innerHTML = fresh.innerHTML;
        }
      }
    } catch (err) { /* silent */ }
  }

  /* -- Intercept product form submit to use cart API - */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (form.id === 'ProductForm') {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Adding…';
      const data = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('add failed');
        await refreshCart();
        openCart();
        btn.innerHTML = 'Added ✓';
        setTimeout(() => { btn.innerHTML = originalText; btn.disabled = false; }, 1500);
      } catch (err) {
        btn.innerHTML = 'Try again';
        setTimeout(() => { btn.innerHTML = originalText; btn.disabled = false; }, 1500);
      }
    }
  });

  /* -- Accordion ------------------------------------- */
  qsa('[data-accordion]').forEach((acc) => {
    qsa('[data-accordion-trigger]', acc).forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const panel = trigger.nextElementSibling;
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (panel) {
          if (isOpen) delete panel.dataset.open;
          else panel.dataset.open = 'true';
        }
      });
    });
  });

  /* -- Product gallery -------------------------------- */
  qsa('[data-product-gallery]').forEach((gallery) => {
    const main = qs('[data-gallery-main]', gallery);
    const mainImg = qs('[data-gallery-image]', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        qsa('[data-gallery-thumb]', gallery).forEach((t) => t.setAttribute('aria-pressed', 'false'));
        thumb.setAttribute('aria-pressed', 'true');
        const src = thumb.dataset.src;
        if (src && mainImg) mainImg.src = src;
      });
    });
  });

  /* -- Quantity input --------------------------------- */
  qsa('[data-quantity]').forEach((wrap) => {
    const input = qs('[data-quantity-input]', wrap);
    qs('[data-quantity-minus]', wrap)?.addEventListener('click', () => {
      const v = parseInt(input.value || '1', 10);
      input.value = Math.max(1, v - 1);
    });
    qs('[data-quantity-plus]', wrap)?.addEventListener('click', () => {
      const v = parseInt(input.value || '1', 10);
      input.value = v + 1;
    });
  });

  /* -- Variant picker (simple) ------------------------ */
  qsa('[data-variant-option]').forEach((select) => {
    // Placeholder - real variant logic would fetch variant ID and update the hidden input/price.
  });

  /* -- Wishlist (localStorage-based) ----------------- */
  const WL_KEY = 'cgg_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch(e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch(e) {}
    updateWishlistButtons();
  }
  function updateWishlistButtons() {
    const list = getWishlist();
    qsa('[data-wishlist-btn]').forEach((btn) => {
      const id = btn.dataset.productId;
      btn.classList.toggle('is-saved', list.indexOf(id) > -1);
      btn.setAttribute('aria-pressed', list.indexOf(id) > -1);
    });
    const count = qs('[data-wishlist-count]');
    if (count) count.textContent = list.length;
  }
  qsa('[data-wishlist-btn]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const id = btn.dataset.productId;
      const list = getWishlist();
      const idx = list.indexOf(id);
      if (idx > -1) list.splice(idx, 1); else list.push(id);
      setWishlist(list);
    });
  });
  updateWishlistButtons();

  /* -- Recently viewed -------------------------------- */
  const RV_KEY = 'cgg_recently_viewed';
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch(e) { return []; }
  }
  function setRecent(list) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8))); } catch(e) {}
  }
  const rvCurrent = qs('[data-product-handle]');
  if (rvCurrent) {
    const handle = rvCurrent.dataset.productHandle;
    const list = getRecent().filter((h) => h !== handle);
    list.unshift(handle);
    setRecent(list);
  }
  // Render recently viewed if container present
  const rvContainer = qs('[data-recently-viewed]');
  if (rvContainer) {
    const handles = getRecent().filter((h) => h !== (rvCurrent ? rvCurrent.dataset.productHandle : ''));
    if (handles.length) {
      Promise.all(handles.slice(0, 4).map((h) =>
        fetch('/products/' + h + '.js').then((r) => r.ok ? r.json() : null).catch(() => null)
      )).then((products) => {
        const html = products.filter(Boolean).map((p) => `
          <a href="${p.url}" class="post-card">
            <div class="post-card__media"><img src="${p.featured_image}" alt="${p.title}" loading="lazy"></div>
            <div class="post-card__body">
              <h3 class="post-card__title">${p.title}</h3>
              <div class="post-card__meta">$${(p.price/100).toFixed(2)}</div>
            </div>
          </a>`).join('');
        if (html) {
          rvContainer.innerHTML = `<h3 class="text-center" style="margin-bottom:1.5rem;">Recently viewed</h3><div class="blog-grid">${html}</div>`;
          rvContainer.style.maxWidth = '1100px';
          rvContainer.style.margin = '3rem auto';
          rvContainer.style.padding = '0 1.5rem';
        }
      });
    }
  }

  /* -- Sticky mobile ATC ----------------------------- */
  const stickyAtc = qs('[data-sticky-atc]');
  const productForm = qs('#ProductForm');
  if (stickyAtc && productForm) {
    const atcButton = qs('[data-sticky-atc-btn]');
    const showAt = 400;
    window.addEventListener('scroll', () => {
      stickyAtc.classList.toggle('is-visible', window.scrollY > showAt);
    }, { passive: true });
    if (atcButton) {
      atcButton.addEventListener('click', (e) => {
        e.preventDefault();
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.click();
      });
    }
  }

})();
